import React , { Component } from 'react';
import { Link } from 'react-router';
import Header from './../Categories/Common/Header.js';
import Footer1 from './../Categories/Common/Footer1.js';
import $ from 'jquery';

export default class Home extends Component{
	constructor(props){
		super(props);
		this.getDeviceId=this.getDeviceId.bind(this);
	}
	componentDidMount()
	{
		if(screen.width >= 800 )
		{
			window.location.href="/web/aboutus";
		}
		this.getDeviceId();
	}
	getDeviceId()
	{
	    if(localStorage.user_id)
	    {
	    	var user_id=localStorage.user_id;
	    }
	    else
	    {
	    	user_id=0;
	    }
		var data1={from:'mobile_web',id:user_id,device_id:localStorage.getItem('push_device_id')}
	    var data2=JSON.stringify(data1);
	    var baseUrl='https://aquadeals.in/admin/web3/user/';
	    $.ajax({
	        method: 'POST',
	        url: baseUrl+'getDeviceId',
	        dataType: 'json',
	        data:{req: data2},
	        success: function(data)
	        {
	          // console.log(data);    
	        },
	        error: function(err)
	        {
	          // console.log(err);
	        }
	    });
	}
	
	render(){
	document.title ="AquaDeals - Online AquaCulture MarketPlace  Find best deals on Seed, Feed, Health Care, Machinery & Farm Equipments, Products, Ropes & Nets Paddle Wheels and More | AquaDeals";
    document.getElementsByTagName("META")[2].content="It is a place for deals related to Aqua culture";
	return(
		<div className="mob_deals">
		<Header />
		<div className="clr">&nbsp;</div>
		<div className="clr">&nbsp;</div>
		<section className="indx_hdr">
		<div className="clr">&nbsp;</div>
		<div className="clr">&nbsp;</div>
		<div className="container tp_block">
			<div className="row">
			  <div className="col-md-5 col-md-offset-1 col-sm-6">
				<h2>Welcome to Aquadeals</h2>
				<p>For fast and safe orders  of Seed, Feed, Health Care, Machinery & Farm Equipment  experience the AquaDeals app on your Android phone and order on the GO! We are sure you will find the best deals every time. Invite your Contacts and get AquaCash. Refer your friends to download the AquaDeals app, sign up using your referral code and earn Rs. 2000 AquaCash. Your friend gets Rs. 2000 AquaCash. And there’s more.</p>
				<ul className="top_btns_blk">
					<li><Link to="/" className="top_btns">Explore AquaDeals</Link></li>
					<li><Link to={"/enquire_now/partner/support/sid/did"} className="top_btns">Join as Partner</Link></li>
				</ul>
			</div>
	<div className="col-md-6 col-sm-6">
	<div className="top_rgt_mble">
		<img src={'https://aquadeals.in/admin/assets/icons/web_icons/mobile.png'} alt="Aqua" />
	</div>
	</div>
	</div>
	</div>

</section>
{/* header end */}
{/* features blk start */}
<section className="features_blk">
<div className="topright"></div>
<div className="container">
<div className="features_cntnt">
<div className="row">
	<div className="col-md-8">
		<div className="row features_blk_cntnt">
			<div className="col-md-5">
				<img src={'https://aquadeals.in/admin/assets/icons/web_icons/deals.png'} alt="Deal"/>
				<h4>D<span>eal</span>s</h4>
				<p>Search several deals on Seed, Feed, Health Care, Machinery & Farm Equipment etc right from your mobile.</p>
			</div>
			<div className="col-md-5">
				<img src={'https://aquadeals.in/admin/assets/icons/web_icons/bookings.png'}  alt="Orders"/>
				<h4>ORDERS</h4>
				<p>Save finding, meeting and negotiating time. Now, find &amp; order your deal in 3 simple steps wherever you are</p>
			</div>
		</div>
		<div className="row features_blk_cntnt">
			<div className="col-md-5">
				<img src={'https://aquadeals.in/admin/assets/icons/web_icons/offers.png'} alt="Offers"/>
				<h4>Spec<span>ial Off</span>ers</h4>
				<p>Celebrate the best of offers that you can ever get for your aqua business. Profit, Share, WalletUp!</p>
			</div>
			<div className="col-md-5">
				<img src={'https://aquadeals.in/admin/assets/icons/web_icons/refer.png'} alt="Refer"/>
				<h4>Ref<span>er &amp; Ea</span>rn</h4>
				<p>Fill your wallet with the magical AquaCash by just sharing with your friends across the world on how you got better business with AD. Bestow Smiles!</p>
			</div>
		</div>
	</div>
	<div className="col-md-4">
		<h2>Feat<span>ures</span></h2>
		<h6>For fast and safe orders of Seed, Feed, Health Care, Machinery & Farm Equipment experience the AquaDeals app on your Android phone and order on the GO! We are sure you will find the best deals every time. Invite your Contacts and get AquaCash.</h6>
	</div>
</div>

</div>
</div>
<div className="bottomleft"></div>
</section>
{/* features blk end */}
{/* aquacash start */}
<section className="aquacash_blk">
	<div className="container">
		<div className="row">
			<div className="col-md-7">
			<div className="aquacash_mble">
				<img src={'https://aquadeals.in/admin/assets/icons/web_icons/aquacash.png'} alt="Aqua"/>
			</div>
			</div>
			<div className="col-md-4">
				<h4>AquaCash</h4>
				<p>We respect your time and so reveal you from the fuss of banking everytime. Virtual money makes your life easy!</p>
			</div>
		</div>
	</div>
	<div className="clr">&nbsp;</div>
<div className="clr">&nbsp;</div>
<div className="clr">&nbsp;</div>	<div className="clr">&nbsp;</div>
<div className="clr">&nbsp;</div>
<div className="clr">&nbsp;</div>	<div className="clr">&nbsp;</div>
<div className="clr">&nbsp;</div>
<div className="clr">&nbsp;</div>
</section>
{/* aquacash end */}
{/*  status block start  */}
<section className="status_blk">
<div className="topright"></div>
<div className="container">
<ul className="status_div">
<li className="col-md-4 col-sm-4 col-xs-4">
		<img src={'https://aquadeals.in/admin/assets/icons/web_icons/users.png'} alt="users"/>
		<h4>20,000+</h4>
		<p>Users</p>
</li>
<li className="col-md-4 col-sm-4 col-xs-4">
		<img src={'https://aquadeals.in/admin/assets/icons/web_icons/partners.png'} alt="Partners" />
		<h4>210</h4>
		<p>Partners</p>
</li>
<li className="col-md-4 col-sm-4 col-xs-4">
		<img src={'https://aquadeals.in/admin/assets/icons/web_icons/hatchery.png'} alt="Hatcheries" />
		<h4>463</h4>
		<p>Hatcheries</p>
</li>
</ul>
</div>
{/* <div className="bottomleft"></div> */}
</section>
{/*  status block end  */}
{/*  brands start  */}
<section className="brands_blk thumbnail">
<div className="container">
	<div id="carousel-example-generic" className="carousel slide" data-ride="carousel">


  {/* Wrapper for slides */}
  <div className="carousel-inner" role="listbox">
<div className="item active">
<div className="col-md-2 col-sm-3 col-xs-3"><img src={'https://aquadeals.in/admin/assets/icons/web_icons/brand_1.jpg'} alt="..." /></div>
<div className="col-md-2 col-sm-3 col-xs-3"><img src={'https://aquadeals.in/admin/assets/icons/web_icons/brand_2.jpg'} alt="..." /></div>
<div className="col-md-2 col-sm-3 col-xs-3"><img src={'https://aquadeals.in/admin/assets/icons/web_icons/brand_3.jpg'} alt="..." /></div>
<div className="col-md-2 col-sm-3 col-xs-3"><img src={'https://aquadeals.in/admin/assets/icons/web_icons/brand_4.jpg'} alt="..." /></div>
<div className="col-md-2 col-sm-3 col-xs-3 hidden-sm hidden-xs"><img src={'https://aquadeals.in/admin/assets/icons/web_icons/brand_5.jpg'} alt="..." /></div>
<div className="col-md-2 col-sm-3 col-xs-3 hidden-sm hidden-xs"><img src={'https://aquadeals.in/admin/assets/icons/web_icons/brand_6.jpg'} alt="..." /></div>
</div>
<div className="item">
<div className="col-md-2 col-sm-3 col-xs-3"><img src={'https://aquadeals.in/admin/assets/icons/web_icons/brand_7.jpg'} alt="..." /></div>
<div className="col-md-2 col-sm-3 col-xs-3"><img src={'https://aquadeals.in/admin/assets/icons/web_icons/brand_8.jpg'} alt="..." /></div>
<div className="col-md-2 col-sm-3 col-xs-3"><img src={'https://aquadeals.in/admin/assets/icons/web_icons/brand_9.jpg'} alt="..." /></div>
<div className="col-md-2 col-sm-3 col-xs-3"><img src={'https://aquadeals.in/admin/assets/icons/web_icons/brand_10.jpg'} alt="..." /></div>
<div className="col-md-2 col-sm-3 col-xs-3 hidden-sm hidden-xs"><img src={'https://aquadeals.in/admin/assets/icons/web_icons/brand_1.jpg'} alt="..." /></div>
<div className="col-md-2 col-sm-3 col-xs-3 hidden-sm hidden-xs"><img src={'https://aquadeals.in/admin/assets/icons/web_icons/brand_2.jpg'} alt="..." /></div>
</div>

  </div>

 
</div>
</div>
</section>
<Footer1 />
		</div>

		);
	}
}


/** WEBPACK FOOTER **
 ** ./src/components/Home/Home.js
 **/